<template>
  <b-card title="GVP Yapılandırması">
    <b-form-group
      label="Terminal ID (TID)"
      label-for="gvp_terminal_id"
    >
      <b-form-input
        id="gvp_terminal_id"
        v-model="gvp_terminal_id"
        placeholder="Terminal ID (TID)"
      />
    </b-form-group>
    <b-form-group
      label="Merchant ID (MID)"
      label-for="gvp_merchant_id"
    >
      <b-form-input
        id="gvp_merchant_id"
        v-model="gvp_merchant_id"
        placeholder="Merchant ID (MID)"
      />
    </b-form-group>
    <b-form-group
      label="Müşteri Adı (Kullanıcı Adı, User Name)"
      label-for="gvp_user_name"
    >
      <b-form-input
        id="gvp_user_name"
        v-model="gvp_user_name"
        placeholder="Müşteri Adı (Kullanıcı Adı, User Name)"
      />
    </b-form-group>
    <b-form-group
      label="Provizyon Şifresi (Provaut Password)"
      label-for="gvp_provaut_password"
    >
      <b-form-input
        id="gvp_provaut_password"
        v-model="gvp_provaut_password"
        placeholder="Provizyon Şifresi (Provaut Password)"
      />
    </b-form-group>
    <b-form-group
      label="3D Şifresi (3D Store Key, Merchant Key)"
      label-for="gvp_3d_store_key"
    >
      <b-form-input
        id="gvp_3d_store_key"
        v-model="gvp_3d_store_key"
        placeholder="3D Şifresi (3D Store Key, Merchant Key)"
      />
    </b-form-group>
    <b-form-group
      label="Doğrudan Ödeme Bağlantısı (Api-Classic URL)"
      label-for="gvp_api_url"
    >
      <b-form-input
        id="gvp_api_url"
        v-model="gvp_api_url"
        placeholder="Doğrudan Ödeme Bağlantısı (Api-Classic URL)"
      />
    </b-form-group>
    <b-form-group
      label="3D Bağlantısı (3D, 3DGate URL)"
      label-for="gvp_3d_url"
    >
      <b-form-input
        id="gvp_3d_url"
        v-model="gvp_3d_url"
        placeholder="3D Bağlantısı (3D, 3DGate URL)"
      />
    </b-form-group>
  </b-card>
</template>
<script>
import { BCard, BFormGroup, BFormInput } from 'bootstrap-vue'
import { configField } from '@/views/PosConfigs/Configs/configBind'

export default {
  name: 'Gvp',
  components: {
    BCard,
    BFormGroup,
    BFormInput,
  },
  computed: {
    posConfig() {
      return this.$store.getters['posConfigs/getPos_config']
    },
    gvp_terminal_id: configField('gvp_terminal_id'),
    gvp_merchant_id: configField('gvp_merchant_id'),
    gvp_user_name: configField('gvp_user_name'),
    gvp_provaut_password: configField('gvp_provaut_password'),
    gvp_3d_store_key: configField('gvp_3d_store_key'),
    gvp_api_url: configField('gvp_api_url'),
    gvp_3d_url: configField('gvp_3d_url'),
  },
}
</script>
<style scoped></style>
